module.exports = window.wp.dom;